import { Component } from '@angular/core';
import { Platform } from '@angular/cdk/platform';


@Component({
  selector: 'app-incognito-modal',
  templateUrl: './incognito-modal.component.html',
  styleUrls: ['./incognito-modal.component.scss']
})
export class IncognitoModalComponent {

  constructor(
    public platform: Platform
  ) { }

}
